import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Mobilemwn from "./Mobilemwn";
import CartContext, { CartProvider } from "./CartContext";

function Layout() {
  return (
    <Fragment>
      <Mobilemwn />
      <Navbar />
      <Outlet />
      <Footer />
    </Fragment>
  );
}

export default Layout;
